import React from "react";
import CorouselFeed from "../../../../../components/commons/CorouselFeed";
import PeopleYouMayKnow from "../../../../../components/commons/PeopleYouMayKnowFeed";
import UpskillingFeed from "../../../../../components/commons/UpskillingFeed";
// import {} from '../'

import styles from "../../../Profile.module.css";

export default class RightFeed extends React.Component {
  corouselContent = [
    {
      img: "/Image/adds/new_profile_img_1.png",
      href: "https://www.midjourney.com/home",
    },

    {
      img: "/Image/adds/new_profile_img_2.png",
      href: "https://runwayml.com/",
    },

    {
      img: "/Image/adds/new_profile_img_3.jpg",
      href: "https://www.perplexity.ai/",
    },

    {
      img: "/Image/adds/new_profile_img_4.jpg",
      href: "https://www.grammarly.com/",
    },
  ];

  render() {
    return (
      <div>
        <div className={styles.rightSide}>
          <CorouselFeed corouselContent={this.corouselContent} />

          <br />

          <PeopleYouMayKnow hamburgerDisplay={this.props?.hamburgerDisplay} />
        </div>
      </div>
    );
  }
}
